export function localIsoDate(date = new Date()): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function formatDate(value: string, options?: Intl.DateTimeFormatOptions): string {
  return new Intl.DateTimeFormat('cs-CZ', options ?? {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(new Date(`${value}T12:00:00`))
}

export function formatDuration(seconds: number): string {
  if (seconds <= 0) return '0 min'
  const minutes = Math.round(seconds / 60)
  const hours = Math.floor(minutes / 60)
  const rest = minutes % 60
  if (hours === 0) return `${minutes} min`
  return rest ? `${hours} h ${rest} min` : `${hours} h`
}

export function formatPrescription(
  axis: string,
  targets: number[],
  load: number | null,
): string {
  if (axis === 'PracticeMinutes') {
    if (targets.length === 0) return 'voln?'
    if (targets.length === 1) return `${targets[0]} min praxe`
    return targets.every((value) => value === targets[0])
      ? `${targets.length} ? ${targets[0]} min praxe`
      : targets.map((value) => `${value} min praxe`).join(' ? ')
  }

  const suffix = axis === 'HoldSeconds' ? 's' : 'opakování'
  const target = targets.length === 0
    ? 'volně'
    : targets.every((value) => value === targets[0])
      ? `${targets.length} série × ${targets[0]} ${suffix}`
      : targets.map((value) => `${value} ${suffix}`).join(' · ')
  if (load === null) return target
  if (load === 0) return `${target} · bez přidané zátěže`
  return `${target} · ${load > 0 ? '+' : ''}${load} kg`
}

export function workoutStatusLabel(status: string): string {
  const labels: Record<string, string> = {
    Planned: 'Naplánováno',
    InProgress: 'Rozpracováno',
    Completed: 'Dokončeno',
    Skipped: 'Vynecháno',
  }
  return labels[status] ?? status
}

export function rolloutLabel(mode: string): string {
  const labels: Record<string, string> = {
    Shadow: 'AI pouze sleduje',
    Suggest: 'AI navrhuje',
    AutoApply: 'Automatické změny',
  }
  return labels[mode] ?? mode
}